import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import {
  fontCondensed,
  fontShentox,
  fontKnockout,
  fontNormal
} from "@fdr/static-ui/Typography";

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .no-event-title {
    font-family: ${fontKnockout};
    text-transform: uppercase;
    display: flex;
    flex-flow: row nowrap;

    &:last-child {
      margin-left: 4px;
    }
  }
`;

export const EventDescription = styled.div<{
  $fontSize: number;
  raceEnded: boolean;
}>`
  z-index: 3;
  display: flex;
  ${({ raceEnded }) =>
    raceEnded
      ? `background-color: ${buildColor("navy", "700")};`
      : `background-color: ${buildColor("blue", "950")};`}
  color: ${buildColor("white", "100")};
  padding: 0 6px;
  font-family: ${fontNormal};
  font-size: ${({ $fontSize }) => $fontSize || 16}px;
  justify-content: center;
  align-items: center;

  b {
    color: ${buildColor("yellow")};
    font-weight: inherit;
  }
`;

export const Body = styled.div<{
  raceEnded?: boolean;
}>`
  z-index: 3;
  display: flex;
  ${({ raceEnded }) =>
    raceEnded
      ? `background-color: ${buildColor("navy", "700")};`
      : `background-color: ${buildColor("blue", "950")};`}
  color: ${buildColor("white", "100")};
  padding: 0 6px;
  font-family: ${fontShentox};
  justify-content: center;
  align-items: center;

  & > * {
    &:first-child {
      margin-right: 4px;
    }
  }
  .countdown-text {
    font-family: ${fontNormal};
  }
`;

export const MiddleBorder = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  transform: translate(50%, -50%);
  background-color: ${buildColor("blue", "300")};
  top: 50%;
  right: 50%;
  z-index: 2;
`;

export const TimerNumber = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin-right: 3px;
  margin-top: 3px;
`;

export const TimerTimeUnit = styled.div`
  font-size: 12px;
  margin-right: 3px;
  font-family: ${fontCondensed};
  color: ${buildColor("white", "100")};
`;
